import { FC, Fragment } from 'react';

import IconUser from '@/assets/user.svg?react';

import IconClose from '@/assets/close.svg?react';
import IconMenu from '@/assets/menu.svg?react';
import { ScrollArea } from '@/components/ui/Select/ScrollArea';
import ClientCardClaimPanel from '@/features/claimPanel/components/ClientCardClaimPanel';
import ClientCardHH from '@/features/v2/hh/components/layout/ClientCardHH';
import ClientCardVD from '@/features/v2/vehicle-damage/components/layout/ClientCardVD';
import cn from '@/utils/cn';

import { Popover, Transition } from '@headlessui/react';
import { RemoveScroll } from 'react-remove-scroll';

export enum CaseCardVariants {
  VEHICLE_DAMAGE = 'vehicle-damage',
  CLAIM_PANEL = 'claim-panel',
  EMPTY = 'empty',
  HOUSE_HOLD = 'house-hold',
}

interface Props {
  crmUser?: {
    name: string;
    avatar: string;
  };
  leadID?: number;
  caseCardVariant: CaseCardVariants;
  isOfferPage?: boolean;
}

const MobileMenu: FC<Props> = ({ caseCardVariant, isOfferPage }) => {
  return (
    <div className="absolute left-0 top-0 z-50 h-[64px] w-full">
      <Popover>
        {({ open }) => {
          return (
            <>
              <div className="mx-auto flex w-full justify-end px-4 py-[11px] sm:max-w-screen-sm md:max-w-tablet md:px-6 lg:px-8">
                <Popover.Button
                  name="Menu"
                  className=" rounded-[10px] bg-primary p-3"
                >
                  <span className="relative block size-[18px]">
                    <IconClose
                      width={18}
                      className={cn(
                        'absolute text-white opacity-0 transition-opacity duration-300',
                        open && 'opacity-100'
                      )}
                    />
                    {caseCardVariant !== CaseCardVariants.CLAIM_PANEL && (
                      <IconMenu
                        width={18}
                        className={cn(
                          'absolute opacity-100 transition-opacity duration-300',
                          open && 'opacity-0'
                        )}
                      />
                    )}
                    {caseCardVariant === CaseCardVariants.CLAIM_PANEL && (
                      <IconUser
                        width={18}
                        className={cn(
                          'absolute text-white opacity-100 transition-opacity duration-300',
                          open && 'opacity-0'
                        )}
                      />
                    )}
                  </span>
                </Popover.Button>
              </div>
              <Transition
                as={Fragment}
                enter="transition-all ease-out duration-300"
                enterFrom="h-0"
                enterTo="h-[100dvh]"
                leave="transition-all ease-in  duration-200"
                leaveFrom="h-[100dvh]"
                leaveTo="h-0"
              >
                <Popover.Panel
                  className={cn(
                    'z-50 mb-auto w-full max-w-full overflow-hidden bg-oxford-blue-400 pr-1'
                  )}
                >
                  <RemoveScroll className="h-[100dvh]">
                    <ScrollArea
                      thumbClassName="bg-transparent hover:bg-transparent sm:bg-gray-200 sm:hover:bg-gray-300 transition-colors"
                      barClassName="bg-transparent hover:bg-transparent sm:bg-oxford-blue-200 sm:hover:bg-oxford-blue-100 transition-colors"
                    >
                      <div
                        className={cn(
                          'mx-auto h-mobile-content sm:max-w-screen-sm md:max-w-tablet lg:max-w-screen',
                          'pl-3 xxs:pl-4 md:pl-6 lg:pl-8',
                          'pr-2 xxs:pr-3 md:pr-5 lg:pr-7',
                          'pt-4'
                        )}
                      >
                        {caseCardVariant ===
                          CaseCardVariants.VEHICLE_DAMAGE && (
                          <ClientCardVD
                            isMobileMenu
                            isOfferPage={isOfferPage}
                          />
                        )}
                        {caseCardVariant === CaseCardVariants.CLAIM_PANEL && (
                          <ClientCardClaimPanel />
                        )}
                        {caseCardVariant === CaseCardVariants.HOUSE_HOLD && (
                          <ClientCardHH
                            isMobileMenu
                            isOfferPage={isOfferPage}
                          />
                        )}
                      </div>
                    </ScrollArea>
                  </RemoveScroll>
                </Popover.Panel>
              </Transition>
            </>
          );
        }}
      </Popover>
    </div>
  );
};

export default MobileMenu;
